/*
* @Des 组件 电子围栏
* @Description
* @Author 
* @Date 2021/7/31
*/
<template>
	<div class="view-tree-table" style="">
		<!-- router-title-box start -->
          <div class="router-title-box" >
            <div class="router-title-item">
            	<a href="javascript:void(0);" class="router-title-back cursor-pointer" @click="closeRouter" title="返回首页"></a>
	            <div class="router-title-tit">
	            	
	            	<!-- tabs start -->
	            	<el-tabs :class="{'whole-page-tabs': true, 'has-right-items': rightItemsFlag}" v-model="activeName" @tab-click="handleClick" tab-position="top" >
						<el-tab-pane v-for="item in eTypes" :key="item.paramKey" :label="item.label" :name="item.paneName" :eType="item.val" ></el-tab-pane>
					</el-tabs>
	            	<!-- tabs end -->
	            	
	            </div>
            </div>
          </div>
        <!-- router-title-box end -->
		
		<div style="height: calc(100% - 84px);">
			<ElectronicFence ref="electronicFence" :activePane="activePane" @changeRightFlag="changeRightFlag" />
		</div>
	</div>
</template>

<script>
	// 引入组件 电子围栏
	import ElectronicFence from '@/components_pages/Fence/ElectronicFence'
	// 参数信息 API
    import ApiParam from '@/request/api-param'
	
	export default {
		/**
		 * @Des 组件名称
		 * @Auth
		 * @Date 2021/7/31
		 */
		name: "FenceSet",
		/**
		 * @Des 组件注册
		 * @Auth
		 * @Date 2021/7/31
		 */
		components: {
			// 组件 电子围栏
			ElectronicFence,
		},
		data() {
			return {
				// 默认选中项
				activeName: 'first',
				// 选中 值
				activePane: {
					// 电子围栏类型
					eType: '1',
					// tab title
					label: '入界区域',
				},
				/**
				 * @Des 围栏 报警类型
				 * @Auth
				 * @Date 2021/7/31
				 */
				eTypes: [],
				
				// 右侧内容
				rightItemsFlag: true,
			}
		},
		mounted(){
			// 查询围栏类型
			this.searchETypes();
		},
		methods: {
			/**
			 * @Des 关闭路由
			 * @Auth
			 * @Date
			 */
			closeRouter () {
				// 跳转到 首页
				this.$router.replace({path: this.$store.state.homePage}, ()=>{}, ()=>{});
			},// closeRouter
			
			/**
			 * @Des 右侧内容 是否为空
			 * @Auth
			 * @Date
			 */
			changeRightFlag (flag) {
				// 右侧内容
				this.rightItemsFlag = flag && true;
			},// changeRightFlag
			
			/**
			 * @Des 点击 tab
			 * @Auth
			 * @Date 
			 */
			handleClick(tab, event) {
				
				this.activePane.eType = String(tab.$attrs.eType);
				this.activePane.label = String(tab.label);
				
				// 查询电子围栏
            	this.$refs.electronicFence.searchFence();
				
				//this.$refs.electronicFence.searchUserGroup();
				if (tab.index == 0) {
					// 请求1
				} else if (tab.index == 1) {
					// 请求2
				} else if (tab.index == 2) {
					// 请求3
				}
			},// handleClick
			/**
			 * @Des 查询围栏类型
			 * @Auth
			 * @Date
			 */
			searchETypes() {
				this.$SubFn.searchETypes(this, (data) => {
					// 围栏 报警类型
					this.eTypes = Object.assign([], data);
				});
			},
		}
	}
</script>

/* CSS */
<style lang="scss" scoped>
	
</style>



// WEBPACK FOOTER //
// src/views/system-manager/fence/FenceSet.vue